import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import PanelContentWrapper from '../../components/PanelContentWrapper';
import { AdminForm } from './AdminForm';
import { apiUrl } from '../../api';
import { Permission } from '../../hooks/Permission';

export const AdminEdit = () => {
    const match = useRouteMatch();
    const token = useSelector((store) => store.token);
    const [user, setUser] = useState({ permissions: [] });

    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        axios
            .get(`${apiUrl}/permission`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(({ data: { permissions: newPermissions } }) => {
                setPermissions(newPermissions);
            });
    }, [token]);

    useEffect(() => {
        axios
            .get(`${apiUrl}/user/${match.params.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(({ data: { user: newUser } }) => {
                setUser(newUser);
            });
    }, [token, match.params.id]);

    return (
        <>
            <Permission permission="admin-update" />
            <PanelContentWrapper>
                <AdminForm
                    initialValues={{
                        ...user,
                        permissions: [
                            ...permissions.map((permission) => {
                                return {
                                    ...permission,
                                    isSelected: user.permissions.map(({ id: mapId }) => mapId).includes(permission.id),
                                };
                            }),
                        ],
                    }}
                    id={match.params.id}
                    onSubmit={(values) => {
                        axios
                            .put(`${apiUrl}/user/${match.params.id}`, values, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            })
                            .then(({ data: { user: newUser } }) => {
                                setUser(newUser);
                                NotificationManager.success('Zapisano zmiany');
                            })
                            .catch(() => {
                                NotificationManager.error('spróbuj ponownie', 'Błąd ');
                            });
                    }}
                />
            </PanelContentWrapper>
        </>
    );
};
